import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {ToastrService} from 'ngx-toastr';
import {take} from 'rxjs/operators';
import {faCrosshairs, faImage, faPlayCircle, IconDefinition} from "@fortawesome/free-solid-svg-icons";
import {Router} from "@angular/router";
import {BlockBaseComponent} from "../scene-blocks/block-base/block-base.component";
import {ContainerService, StoreSelectorsService} from "../../../services";
import {IButtonBar} from "../../../components/add-remove-bar/button-bar.component";
import {ITableListColumn, ITableListEvent} from "../../../components/table-list-input/table-list-input.component";
import {actionSceneItemPlaylist, actionSceneJumpLinked} from "../../../store/actions/user.actions";
import {compareIds, getTotalLengthPlaylist, isNullOrUndef, isNullOrUndefOrEmpty, MAX_PLAYLIST_TIME} from "../../../common";
import {ITableIconPipe} from "../../../pipes/table-list-icon-pipe";
import {Memoizee} from "../../../decorators/memoizee-decorator";
import {DialogGetAssetComponent, IDialogGetAsset} from "../../../components/dialog-get-asset/dialog-get-asset.component";
import {SceneMimeTypes} from "../scene-blocks/mime-constants";
import {Lib} from "../../../../libs/Lib";
import {IPage} from "../../../interfaces";
import {Color, ScaleType} from "@swimlane/ngx-charts";
import * as _ from "lodash";

// normalize by repetition
// normalize by duration

@Component({
    selector: 'app-block-hourlybalancer',
    templateUrl: './block-hourlybalancer.component.html',
    styleUrls: ['./block-hourlybalancer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlockHourlybalancerComponent extends BlockBaseComponent {
    showPie = false;
    buttons: IButtonBar[] = [];
    tableColumns: Array<ITableListColumn> = [];
    totalPercentage = 0;
    dataStoragePercent = [
        {
            name: "cloud storage",
            value: 50
        },
        {
            name: "used storage",
            value: 30
        }
    ];
    colorScheme: Color = {
        name: 'Customer Usage',
        selectable: true,
        group: ScaleType.Ordinal,
        domain: ['#5AA454', '#E44D25', '#aae3f5', '#CFC0BB', '#7aa3e5', '#a8385d', '#5AA454', '#E44D25', '#aae3f5', '#CFC0BB', '#7aa3e5', '#a8385d']
    };


    constructor(private translocoService: TranslocoService,
                public override storeSelector: StoreSelectorsService,
                private toastr: ToastrService,
                public override dialog: MatDialog,
                private containerService: ContainerService,
                public cd: ChangeDetectorRef, private router: Router
    ) {
        super(storeSelector, dialog);
        this.tableColumns = [
            {
                inputType: 'text',
                name: 'page',
                maxStringSize: '30'
            },
            {
                inputType: 'edit',
                name: 'duration',
                label: 'seconds',
                maxStringSize: '3'
            },
            {
                inputType: 'edit',
                name: 'repetitions',
                label: 'rep/h',
                maxStringSize: '3'
            },
            {
                inputType: 'text',
                name: 'percentage',
                label: '(%)',
                maxStringSize: '8'
            }
        ];
        this.buttons = [
            // {
            //     callBack: v => (v),
            //     icon: 'playlist_add',
            //     name: 'list',
            //     disableByList: false,
            //     disabled: false,
            //     tooltip: this.translocoService.translate('general.playlistTimeline', {}, this.translocoService.getActiveLang())
            // },
            {
                callBack: v => (v),
                icon: 'add',
                name: 'add',
                disableByList: false,
                disabled: false,
                tooltip: this.translocoService.translate('general.add', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'link',
                name: 'link',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.jumpToScene', {}, this.translocoService.getActiveLang()),
                callbackStatus: v => {
                    return this.onCallBackButtonStatus(v);
                }
            },
            {
                callBack: v => {
                    return this.onCallBackStats(v);
                },
                icon: 'pie_chart',
                name: 'pie',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.statistics', {}, this.translocoService.getActiveLang())
            },
            {
                // callBack: v => {
                //     this.normalizeValues();
                //     return v;
                // },
                callBack: v => (v),
                icon: 'remove',
                name: 'remove',
                disableByList: true,
                confirmRemove: this.translocoService.translate('toast.deleteConfirm', {}, this.translocoService.getActiveLang()),
                disabled: false,
                tooltip: this.translocoService.translate('general.remove', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'arrow_left',
                name: 'previous',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.next', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'arrow_right',
                name: 'next',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.previous', {}, this.translocoService.getActiveLang())
            }
        ];
    }

    onPlaylistTimeline() {
        this.containerService.updateEditorMode('playlistMode');
    }

    override componentInit() {
        super.componentInit();

    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
        // super.initApplyStoreToDynamic(true);
        this.cd.markForCheck();
    }

    private onTableListChangeCallBack(e: ITableListEvent) {

        if (e.currentAction === 'selected') {
            this.storeSelector.dispatch(actionSceneItemPlaylist({indexes: e.selectedIndexes}));

        } else if (e.currentAction === 'previous' || e.currentAction === 'next') {
            // this.storeSelector.dispatch(actionSceneItemPlaylist({indexes: e.selectedIndexes}));

        } else if (e.currentAction === 'link') {
            const selected = e.selected[0];
            if (selected?.$?.type === 'scene') {
                this.linkToNestedScene(selected.Player[0].$.src);
            }

        } else if (e.currentAction === 'rename') {
            const oldPages = this.sceneItem.Data[0].HourlyBalancer[0].Page;
            const newPages: IPage[] = e.values;
            const index = e.selectedIndexes[0];
            const newPage = newPages[index];
            const duration = Number(newPage.$.duration);
            const repetitions = Number(newPage.$.repetitions);
            if (duration < 1) newPage.$.duration = '1';
            if (repetitions < 1) newPage.$.repetitions = '1';
            if (newPages && _.isArray(newPages)) {
                this.dispatchSceneItemChanges({
                    sceneId: this.sceneId,
                    sceneItemId: this.sceneItem.$.id,
                    values: [{
                        key: 'Page',
                        value: newPages,
                        storePath: 'Data[0].HourlyBalancer[0]'
                    }]
                });
                super.initApplyStoreToDynamic(true);
            }

        } else if (e.currentAction === 'drop' || e.currentAction === 'removed') {
            this.dispatchSceneItemChanges({
                sceneId: this.sceneId,
                sceneItemId: this.sceneItem.$.id,
                values: [{
                    key: 'Page',
                    value: e.values,
                    storePath: 'Data[0].HourlyBalancer[0]'
                }]
            });
            if (e.currentAction === 'removed') {
                this.storeSelector.dispatch(actionSceneItemPlaylist({indexes: []}));
            }
        } else if (e.currentAction === 'list') {
            this.onPlaylistTimeline();
        } else if (e.currentAction === 'added') {
            this.openAssociateDialog(true, 'Page');
            this.storeSelector.dispatch(actionSceneItemPlaylist({indexes: []}));
        }
        this.calcPie();
    }

    @Memoizee({})
    onCallBackIcon(v: ITableIconPipe): IconDefinition {
        if (v.index === 0) {
            if (v.params.$.type === "scene") {
                return faCrosshairs;
            } else {
                if (compareIds(v.params.Player[0]?.$.player, '3100')) {
                    return faPlayCircle;
                }
                return faImage;
            }
        }
        return null;
    }

    onCallBackStats(event) {
        this.showPie = !this.showPie;
        if (this.showPie) this.calcPie();
        return null;
    }

    /**
     * Set table-list buttons disabled status: if true, button is disabled, else, button is activated.
     * @param event
     * @returns
     */
    onCallBackButtonStatus(event) {
        if (!event || event.length !== 1) {
            return true;
        }
        return event[0].$.type !== 'scene';
    }

    override submit(formValues) {
        super.submit(formValues);
        // if (this.onFormSubmitAction(formValues)) {
        //     super.submit(formValues);
        // }
    }

    linkToNestedScene(src) {
        if (!src) return;
        this.storeSelector.dispatch(actionSceneJumpLinked({previousLinkedSceneId: this.sceneId}));
        this.router.navigateByUrl(`/editor/scene/${src}`);
    }

    // private onFormSubmitAction(e): boolean {
    //     let returnVal = null;
    //     Object.entries(e).map((items: Array<any>) => {
    //         const tableName = items[0];
    //         items.forEach((val: ITableListEvent) => {
    //             if (isNullOrUndef(val?.currentAction)) return returnVal = true;
    //             Lib.DevShow(`>>> onFormSubmitAction ${tableName} | ${val.currentAction}| selected ${val.selected.length} | values ${val.values.length}`);
    //             switch (val.currentAction) {
    //                 case 'selected': {
    //                     return returnVal = false;
    //                 }
    //                 case 'externallySelected': {
    //                     return returnVal = true;
    //                 }
    //                 case 'list': {
    //                     this.onPlaylistTimeline();
    //                     return returnVal = false;
    //                 }
    //                 case 'added': {
    //                     this.openAssociateDialog(true, tableName);
    //                     this.storeSelector.dispatch(actionSceneItemPlaylist({indexes: []}));
    //                     return returnVal = true;
    //                 }
    //                 case 'removed':
    //                 case 'rename': {
    //                     this.calcPie();
    //                     return returnVal = true;
    //                 }
    //                 default: {
    //                     return returnVal = true;
    //                 }
    //             }
    //         });
    //     });
    //     return returnVal;
    // }

    calcPie() {
        if (isNullOrUndef(this.sceneItem.Data[0].HourlyBalancer?.[0]?.Page) || this.sceneItem.Data[0].HourlyBalancer?.[0]?.Page.length === 0) {
            this.showPie = false;
            return;
        }
        if (!this.showPie) return;
        this.dataStoragePercent = [];
        this.sceneItem.Data[0].HourlyBalancer[0].Page.forEach(page => {
            const duration = page?.$?.duration ? page.$.duration : '10';
            const repetitions = page.$.repetitions ? page.$.repetitions : '60';
            const name = page.$.page;
            const value = Math.round((100 * Number(repetitions) * Number(duration)) / 3600);
            this.dataStoragePercent.push({name, value});
        });
    }

    openAssociateDialog(addingNew, tableName: 'pageGps' | 'Page') {
        const data: IDialogGetAsset = {mode: "SCENE_RESOURCE:PLAYER", mimeType: SceneMimeTypes.Player, multiSelect: true};
        const dialogRefVal = this.dialog.open(DialogGetAssetComponent, {
            width: '70%',
            panelClass: 'custom-dlg-container',
            data
        });
        this.cod(
            dialogRefVal.afterClosed()
                .pipe(take(1))
                .subscribe((dialogGetAssets: IDialogGetAsset[]) => {
                    if (!dialogGetAssets || !Array.isArray(dialogGetAssets)) return;

                    this.addTableItem(dialogGetAssets);
                })
        );
    }

    getDuration(currentDuration) {
        const defaultDuration = this.sceneItem.Data[0].HourlyBalancer[0].$.duration;
        if (currentDuration === '0' || isNullOrUndefOrEmpty(currentDuration)) {
            currentDuration = defaultDuration;
        }
        return String(Lib.ParseToFloatDouble(currentDuration));
    }

    addTableItem(dialogGetAssets: IDialogGetAsset[]) {
        let pager: IPage;
        const pages = this.sceneItem.Data[0].HourlyBalancer[0].Page && _.isArray(this.sceneItem.Data[0].HourlyBalancer[0].Page) ? _.cloneDeep(this.sceneItem.Data[0].HourlyBalancer[0].Page) : [];
        let len = getTotalLengthPlaylist(pages);

        for (const dialogGetAsset of dialogGetAssets) {
            switch (dialogGetAsset.selectedType) {
                case "RESOURCE_SELECTED": {
                    const resource_type = dialogGetAsset.sourceData.resource_type.toLowerCase();
                    const playerId = (["mp4", "mov", "m4v", "3gp"].indexOf(resource_type) > -1) ? "3100" : "3130";
                    // const duration = this.getDuration(dialogGetAsset.sourceData?.resource_total_time);
                    pager = {
                        $: {
                            page: `${dialogGetAsset.sourceData.resource_name}`,
                            type: "resource",
                            repetitions: "60",
                            duration: "10"
                        },
                        Player: [
                            {
                                "$": {
                                    player: playerId,
                                    id: _.uniqueId('__')
                                },
                                Data: [
                                    {
                                        Resource: [
                                            {
                                                $: {
                                                    resource: dialogGetAsset.selected
                                                }
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    };
                    if (playerId === '3100') {
                        pager.$.duration = this.getDuration(dialogGetAsset.sourceData?.resource_total_time);
                    }
                    break;
                }
                case "SCENE_SELECTED": {
                    pager = {
                        $: {
                            page: dialogGetAsset.sourceData.Player.$.label,
                            type: "scene",
                            repetitions: "60",
                            duration: "10"

                        },
                        Player: [
                            {
                                $: {
                                    src: dialogGetAsset.selected
                                }
                            }
                        ]
                    };
                    break;
                }
            }

            if (pager.$.duration) {
                len += parseFloat(pager.$.duration);
            }

            if (len > MAX_PLAYLIST_TIME) {
                this.showToastOverLength();
                return;
            }
            pages.push(pager);
        }

        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: 'Page',
                value: pages,
                storePath: 'Data[0].HourlyBalancer[0]'
            }]
        });
        super.initApplyStoreToDynamic(true);
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.hourlyBalancer', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "label",
                storePath: '$.label'
            },
            {
                type: "input",
                label: '',
                inputType: 'tablelist',
                tableColumns: this.tableColumns,
                ignoreMissingValue: true,
                cloneVals: true,
                multiSelect: false,
                rememberSelection: true,
                allowFilter: true,
                allowTableOnDialog: true,
                buttonBarClassName: 'playlistButtonBar',
                buttons: this.buttons,
                inputEditFormat: {page: 'text', duration: 'number', repetitions: 'number', percentage: 'number'},
                requiredFields: {page: true, duration: false},
                inputEditRenamePath: [{path: '$.page', key: 'page'}, {path: '$.duration', key: 'duration'}, {path: '$.repetitions', key: 'repetitions'}, {path: '$.percentage', key: 'percentage'}],
                name: "Page",
                storePath: 'Data[0].HourlyBalancer[0].Page',
                expandableEditor: true,
                enablePagination: true,
                disableSubmit: true,
                callBackValue: (item, direction) => {
                    switch (direction) {
                        case 'IN': {
                            item.$ = {
                                "page": item.$.page,
                                "type": item.$.type,
                                "duration": item.$.duration,
                                "repetitions": item.$.repetitions,
                                "percentage": this.updatePercentage(item)
                            };
                            return item;
                        }
                        case 'OUT': {
                            return item;
                            // return {
                            //     $: {name: item.$.name},
                            //     Player: [{$: {src: item.$.src}}]
                            // };
                        }
                    }
                },
                callBackEvent: (v) => this.onTableListChangeCallBack(v),
                callBackFaIcon: (v) => this.onCallBackIcon(v)
                // callBackFaIcon: (v) => BlockPlaylistComponent.onCallBackFaIcon(v),
            }
            // ,
            // {
            //     type: "checkbox",
            //     value: '1',
            //     inputType: "text",
            //     label: this.translocoService.translate('general.autoStretchDuration', {}, this.translocoService.getActiveLang()),
            //     name: "fillGaps",
            //     storePath: 'Data[0].HourlyBalancer[0].$.fillGaps'
            // },
        ];
    }

    private showToastOverLength() {
        this.toastr.error(this.translocoService.translate('general.tooLong24', {}, this.translocoService.getActiveLang()));
    }


    private updatePercentage(item: IPage): number {

        const pages: IPage[] = this.sceneItem.Data[0].HourlyBalancer[0].Page;
        let totalDuration = 0;
        let pageItemPercent = 0;
        pages.forEach(page => {
            const repetitions = page?.$?.repetitions ? page.$.repetitions : '60';
            const duration = page?.$?.duration ? page.$.duration : '10';
            totalDuration += Number(repetitions) * Number(duration);
        });
        pages.forEach(page => {
            const repetitions = page?.$?.repetitions ? page.$.repetitions : '60';
            const duration = page?.$?.duration ? page.$.duration : '10';
            if (item.Player[0].$.id === page.Player[0].$.id) {
                pageItemPercent = (100 * Number(repetitions) * Number(duration)) / 3600;
            }
        });
        this.totalPercentage = Math.round(totalDuration / 36);
        return Math.round(pageItemPercent);
    }

    normalizeValues() {
        const pages = _.cloneDeep(this.sceneItem.Data[0].HourlyBalancer[0].Page);
        if (pages.length == 0) {
            return;
        }
        let totalDuration = 0;
        pages.forEach(page => {
            totalDuration += Number(page.$.repetitions) * Number(page.$.duration);
        });
        const a = 3600 / totalDuration;
        pages.forEach(page => {
            page.$.repetitions = Math.floor(Number(page.$.repetitions) * a) as any;
        });
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: 'Page',
                value: pages,
                storePath: 'Data[0].HourlyBalancer[0]'
            }]
        });
        super.initApplyStoreToDynamic(true);
    }
}


